import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'soil-test';
// Fixed slots: img[0]=inside intro box (right), img[1]=beside process (field sampling), img[2]=beside features (report accent)
// Additional: img[3+]

const SoilTest = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="st-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        {/* Intro box: with img[0] on right if uploaded, else full-width */}
        {imgs[0] ? (
          <div className="st-intro-wrap">
            <div className="st-intro">
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="st-intro-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="st-intro-solo">
            <p>{data.intro}</p>
            <p>{data.intro2}</p>
          </div>
        )}

        {/* Icon grid features */}
        {data.features && data.features.length > 0 && (
          <div className="st-icon-grid">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="st-icon-card" key={f.title}>
                <div className="icon">{f.icon}</div>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        )}

        {/* Process: steps left + img[1] field sampling right — grid only if image uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          imgs[1] ? (
            <div className="st-proc-wrap">
              <div className="st-process">
                <h2>{data.processTitle}</h2>
                <div className="st-proc-grid">
                  {data.processSteps.map((s) => (
                    <div className="st-proc-item" key={s.step}>
                      <div className="st-proc-num">{s.step}</div>
                      <div>
                        <strong>{s.title}</strong>
                        <span>{s.desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="st-field-img">
                <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
              </div>
            </div>
          ) : (
            <div className="st-process-solo">
              <h2>{data.processTitle}</h2>
              <div className="st-proc-grid">
                {data.processSteps.map((s) => (
                  <div className="st-proc-item" key={s.step}>
                    <div className="st-proc-num">{s.step}</div>
                    <div>
                      <strong>{s.title}</strong>
                      <span>{s.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="st-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > 3 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(3).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default SoilTest;
